// Number工具类
export default class NumberTools {
    // 数字转千分位字符串(每3位加一个,逗号)
    static toLocaleString(val) {
        let caller = "0";
        if (!val) {
            // val为undefined,null,''
            caller = "0";
        } else if (typeof val === "string" || typeof val === "number") {
            // 字符串类型且不为''
            caller = String(val);
        }

        if (caller.indexOf(".") > -1) {
            return (
                parseInt(caller).toLocaleString() + "." + caller.split(".")[1].padEnd(2, '0')
            );
        } else {
            return parseInt(caller).toLocaleString() + '.00';
        }
    }
}



export function getProductAmountPriceAllDx(sum) {
    if (!sum) return '零圆整';

    const num = parseFloat(sum);
    if (isNaN(num) || num < 0) return '零圆整';

    // 金额转大写
    const digitUppercase = (n) => {
        const fraction = ['角', '分'];
        const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
        const unit = [
            ['圆', '万', '亿'],
            ['', '拾', '佰', '仟']
        ];

        const numStr = Math.abs(n).toFixed(2);
        const [integer, decimal] = numStr.split('.');
        let result = '';

        // 处理整数部分
        if (parseInt(integer) === 0) {
            result = '零圆';
        } else {
            const integerNum = parseInt(integer);
            let integerStr = '';
            let zero = false;

            // 将整数转换为中文
            const intDigits = integer.split('');
            const intLen = intDigits.length;

            for (let i = 0; i < intLen; i++) {
                const digitNum = parseInt(intDigits[i]);
                const pos = intLen - i - 1;
                const section = Math.floor(pos / 4);
                const posInSection = pos % 4;

                if (digitNum === 0) {
                    zero = true;
                } else {
                    if (zero && integerStr) {
                        integerStr += '零';
                    }
                    zero = false;
                    integerStr += digit[digitNum];

                    if (posInSection !== 0) {
                        integerStr += unit[1][posInSection];
                    }

                    if (section > 0 && posInSection === 0) {
                        // 处理万、亿单位
                        if (section === 1) {
                            // 检查万位是否为零
                            let hasTenThousand = false;
                            for (let j = i; j < intLen && intLen - j - 1 < 8; j++) {
                                if (parseInt(intDigits[j]) !== 0) {
                                    hasTenThousand = true;
                                    break;
                                }
                            }
                            if (hasTenThousand) {
                                integerStr += unit[0][section];
                            }
                        } else if (section === 2) {
                            integerStr += unit[0][section];
                        }
                    }
                }
            }
            result = integerStr;
            result += '圆';
        }

        // 处理小数部分
        if (decimal && decimal !== '00') {
            if (decimal[0] !== '0') {
                result += digit[parseInt(decimal[0])] + '角';
            }
            if (decimal[1] !== '0') {
                result += digit[parseInt(decimal[1])] + '分';
            }
        } else {
            result += '整';
        }

        // 特殊处理：去除开头的"壹拾"中的"壹"
        result = result.replace(/^壹拾/, '拾');

        return result;
    };

    return digitUppercase(num);
}
export function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
// 限制小数位数，超过指定位数则截取
export function limitDecimals(num, max = 10) {
    const parts = num.toString().split('.');
    if (parts.length === 1) return Number(num);
    if (parts[1].length > max) return Number(Number(num).toFixed(max));
    return Number(num);
}
export function preciseAdd(a, b) {
    const factor = Math.pow(10, 10); // 取10位小数精度
    return (Math.round(a * factor) + Math.round(b * factor)) / factor;
}
//是否是工作日 不是延后一天再检查 返回工作日
export function isWorkDays(date) {
    // 如果没有传入日期，则默认使用当前日期
    if (!date) {
        date = new Date();
    } else if (typeof date === 'string' || typeof date === 'number') {
        date = new Date(date);
    }

    // 检查日期是否有效
    if (isNaN(date.getTime())) {
        throw new Error('Invalid date');
    }

    // 定义节假日（可以根据实际情况调整）
    const holidays = [
        // 元旦
        '01-01', '01-02', '01-03',
        // 春节（可根据当年日期调整）
        '02-15', '02-16', '02-17', '02-18', '02-19', '02-20', '02-21', '02-22', '02-23',
        // 清明节
        '04-04', '04-05', '04-06',
        // 劳动节
        '05-01', '05-02', '05-03', '05-04', '05-05',
        // 端午节
        '06-19', '06-20', '06-21',
        // 中秋节
        '09-25', '09-26', '09-27',
        // 国庆节
        '10-01', '10-02', '10-03', '10-04', '10-05', '10-06', '10-07'
    ];

    // 定义调休工作日（非周末但需要上班的日期）
    const workOnWeekend = [
        // 示例：2026年调休工作日
        '2026-01-04', '2026-02-14', '2026-02-28', '2026-05-09',
        '2026-09-20', '2026-10-10', '2026-09-29', '2026-10-12'
    ];

    // 递归检查日期是否为工作日
    function checkWorkDay(currentDate) {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const monthDay = `${month}-${day}`;
        const fullDate = `${year}-${month}-${day}`;

        // 获取星期几（0是周日，1-6是周一到周六）
        const dayOfWeek = currentDate.getDay();

        // 检查是否是周末（周日或周六）
        const isWeekend = (dayOfWeek === 0 || dayOfWeek === 6);

        // 检查是否是节假日
        const isHoliday = holidays.includes(monthDay);

        // 检查是否是调休工作日
        const isWorkDay = workOnWeekend.includes(fullDate);

        // 判断是否为工作日
        // 如果是周末或节假日且不是调休工作日，则不是工作日
        if ((isWeekend || isHoliday) && !isWorkDay) {
            // 不是工作日，向后推一天
            const nextDay = new Date(currentDate);
            nextDay.setDate(nextDay.getDate() + 1);
            return checkWorkDay(nextDay);
        }

        // 是工作日，返回该日期
        return currentDate;
    }

    return checkWorkDay(date);
}

//时间格式化
export function getYMD(date) {
    if (!date) {
        date = new Date();
    } else if (typeof date === 'string' || typeof date === 'number') {
        date = new Date(date);
    }

    // 检查日期是否有效
    if (isNaN(date.getTime())) {
        throw new Error('Invalid date');
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要+1
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}
// 处理价格输入，限制最多两位小数
export function handlePriceInput(value, row, field) {
    // 验证输入为金额格式且最多两位小数
    const regex = /^([0-9]+\.?[0-9]{0,2})?$/;
    if (regex.test(value) || value === '') {
        // 如果输入符合要求，更新值
        row[field] = value;
    } else {
        // 如果输入不符合要求，截取符合要求的部分
        if (value && value.includes('.')) {
            const parts = value.toString().split('.');
            if (parts[1] && parts[1].length > 2) {
                // 截取前两位小数
                const truncated = parts[0] + '.' + parts[1].substring(0, 2);
                row[field] = truncated;
            }
        } else {
            // 如果输入包含非法字符，恢复之前的值
            const prevValue = row[field] || '';
            // 找到合法的输入部分
            let validInput = '';
            for (let char of value) {
                const testValue = validInput + char;
                if (regex.test(testValue)) {
                    validInput = testValue;
                } else {
                    break;
                }
            }
            row[field] = validInput;
            if (validInput !== value) {
                this.$message.warning('请输入正确的金额格式');
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/numberTools.js